var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, SettingsIcon, Trans, Typography } from '@lucidlink/uicore';
import styles from './FilespaceSettingsHeader.module.css';
export const FilespaceSettingsHeader = () => (_jsxs(Box, { align: "center", className: styles.Container, gap: "m", justify: "center", children: [_jsx(SettingsIcon, { color: "accent" }), _jsx(Typography, { as: "h2", color: "accent", "data-testid": "filespace-settings-title", kind: "h4", children: _jsx(Trans, { children: "Filespace settings" }) })] }));
_react_refresh_temp_1 = FilespaceSettingsHeader;
$RefreshReg$(_react_refresh_temp_1, "FilespaceSettingsHeader");
